export default __webpack_public_path__ + "static/media/moderado.0d0bf738.png";